import { axiosInstance as request } from '@api/rest.service'

const api = '/to-dos/states'

/**
 * @description GET /to-dos/states
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_STATES = () => request.get(api)

/**
 * @description POST /to-dos/states
 * @returns {AxiosPromise<any>}
 */
export const CREATE_TODOS_STATE = payload => request.post(api, payload)

/**
 * @description PUT /to-dos/states/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_TODOS_STATE = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /to-dos/states/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_STATE_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /to-dos/states/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_TODOS_STATE = id => request.delete(`${api}/${id}`)
